import { isEmptyObject } from '../utils/common'
import httpService from '../services/http.service'
import userService from '../services/user.service'
import systemService from '../services/system.service'
import windowService from '../services/window.service'
import { ElMessage } from 'element-plus'

const dataService = function() {
    var pri = {
        getData(tableName, condition) {
            const projectId = systemService.project_id
            return new Promise((resolve, reject) => {
                const data = {}
                if (condition) {
                    Object.assign(data, condition)
                }
                const token = userService?.user?.token
                if (token) {
                    data.token = token
                }
                httpService.post('api-data', { project_id: projectId, name: tableName, method: 'get' }, data).then(datas => {
                    resolve(datas)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        postData(tableName, dataTable, condition) {
            const data = {
                body: {
                    datas: dataTable.datas,
                    changes: dataTable.getChanges()
                }
            }
            if (condition) {
                Object.assign(data, condition)
            }
            const token = userService?.user?.token
            if (token) {
                data.token = token
            }
            return httpService.post('api-data', { project_id: systemService.project_id, name: tableName, method: 'post' }, data)
        },
        putData(tableName, dataTable, condition) {
            const data = {
                body: {
                    datas: dataTable.datas,
                    changes: dataTable.getChanges()
                }
            }
            if (condition) {
                Object.assign(data, condition)
            }
            const token = userService?.user?.token
            if (token) {
                data.token = token
            }
            return httpService.post('api-data', { project_id: systemService.project_id, name: tableName, method: 'put' }, data)
        },
        deleteData(tableName, dataTable, condition) {
            const data = { }
            if (dataTable) {
                data.body = {
                    datas: dataTable.datas,
                    changes: dataTable.getChanges()
                }
            }
            if (condition) {
                Object.assign(data, condition)
            }
            const token = userService?.user?.token
            if (token) {
                data.token = token
            }
            return httpService.post('api-data', { project_id: systemService.project_id, name: tableName, method: 'delete' }, data)
        },
        getDictionary(tableName) {
            // const projectId = systemService.project_id
            // return httpService.get('data-dictionary', { project_id: projectId, name: tableName })

            // 改为从本地获取数据字典
            return new Promise((resolve, reject) => {
                try {
                    const dataDictionary = require(`/public/static/dictionarys/${tableName}.json`)
                    const result = {
                        entity_id: dataDictionary.entity_id,
                        name: dataDictionary.name,
                        caption: dataDictionary.caption,
                        service: dataDictionary?.options?.service,
                        table_name: dataDictionary?.options?.apis?.get?.table_name,
                        columns: dataDictionary.columns,
                        params: dataDictionary?.options?.apis?.get?.params ?? [],
                        query: dataDictionary?.options?.apis?.get?.query ?? []
                    }
                    resolve(result)
                } catch (error) {
                    reject(error)
                }
            })
        },
        getBinding(bindingName) {
            return new Promise((resolve, reject) => {
                try {
                    const result = require(`/public/static/bindings/${bindingName}.json`)
                    resolve(result)
                } catch (error) {
                    reject(error)
                }
            })
        }
    }

    var pub = {
        // 获取数据绑定的定义
        async getBinding(bindingName) {
            return pri.getBinding(bindingName)
        },
        // 获取数据字典
        async getDictionary(tableName) {
            return pri.getDictionary(tableName)
        },
        // 获取数据源查询条件，会弹出查询对话框，返回查询条件，格式： { params: {}, query: {} }
        async getCondition(tableName, defaultCondition) {
            const dataDictionary = await pri.getDictionary(tableName)

            const params = {
                caption: dataDictionary.caption,
                query: dataDictionary?.query ?? [],
                params: dataDictionary?.params ?? [],
                condition: defaultCondition
            }
            // const module = await import('../components/common/query-dialog')
            const module = require('../components/common/query-dialog')
            return windowService.showDialog(module, params)
        },

        // 加载数据表（包括数据字典及数据）
        loadDataTable(tableName, dataTable, condition) {
            dataTable.clear()
            return pri.getDictionary(tableName).then(dataDictionary => {
                dataTable.setColumns(dataDictionary.columns)
                return this.getData(tableName, dataTable, condition)
            })
        },

        // 查询数据表（会弹出查询对话框并使用对话框条件查询并填充数据）
        queryDataTable(tableName, dataTable, defaultCondition) {
            return this.getCondition(tableName, defaultCondition).then(condition => {
                dataTable.clear()
                return this.getData(tableName, dataTable, condition)
            }).catch(err => {
                // 正常关闭对话框时err为空，如有错误会返回错误，所以加上 catch 可以防止因无 catch 报错，但有错误时则需要报出来
                if (err) {
                    throw err
                }
            })
        },

        // 加载数据字典
        loadDataDictionary(tableName, dataTable) {
            return pri.getDictionary(tableName).then(dataDictionary => {
                dataTable.setColumns(dataDictionary.columns)

                return dataTable
            })
        },

        // GET数据（不包括数据字典）
        getData(tableName, dataTable, condition) {
            return pri.getData(tableName, condition).then(async datas => {
                const dataDictionary = await pri.getDictionary(tableName)
                // 如果指定了表名则取该表名的数据（当返回多个数据表时可指定取哪个表的数据）
                if (dataDictionary.table_name) {
                    datas = datas[dataDictionary.table_name]
                }

                if (dataTable?.loadDatas) {
                    // 存在 loadDatas 方法时认为是数据表，调用数据表的加载数据
                    dataTable.loadDatas(datas)
                    if (isEmptyObject(dataTable.current) && dataTable.datas.length) {
                        dataTable.current = dataTable.datas[0]
                    } else {
                        dataTable.current = null
                    }
                } else {
                    // 不存在时认为是 JSON 对象，直接将数据合并到对象中（用于解决非结构化数据，或动态数据）
                    if (dataTable) {
                        Object.assign(dataTable, datas)
                    } else {
                        dataTable = datas
                    }
                }

                return dataTable
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        },

        // POST数据
        postData(tableName, dataTable, condition) {
            return pri.postData(tableName, dataTable, condition)
        },

        // PUT数据
        putData(tableName, dataTable, condition) {
            return pri.putData(tableName, dataTable, condition)
        },

        // DELETE数据
        deleteData(tableName, dataTable, condition) {
            return pri.deleteData(tableName, dataTable, condition)
        },

        // 已改为 getData 方法（即将废除）
        loadData(tableName, dataTable, condition) {
            this.getData(tableName, dataTable, condition)
        },

        // 获取数据（即将废除）
        loadTable(projectId, tableName, condition) {
            return new Promise((resolve, reject) => {
                pri.getDictionary(tableName).then(async dataDictionary => {
                    condition = condition ?? {}
        
                    const token = userService?.user?.token
                    if (token) {
                        condition.token = token
                    }
                    let datas = await httpService.post('api-data', { project_id: projectId, name: tableName, method: 'get' }, condition)
                    // 如果指定了表名则取该表名的数据
                    if (dataDictionary.table_name) {
                        datas = datas[dataDictionary.table_name]
                    }
        
                    resolve({
                        columns: dataDictionary.columns,
                        datas: datas
                    })
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }

    return pub;
}

var service = dataService();

export default service;